// extracted by mini-css-extract-plugin
module.exports = {"icon":"facilityDescription_icon__1zT-2","descriptionContainer":"facilityDescription_descriptionContainer__Hty4w"};